import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

// NOTE: The entity behind this DTO is effectively an owned entity, and is not used outside
// of the context of a parent entity. For this reason, it is not necessary to have a separate
// List or Record versions of it or extend it from the BaseDto.

/**
 * Commission tier item DTO
 */
export class CommissionTierItemDto {
  @TransformInt()
  id?: number;
  uuid!: string;
  description?: string | null;
  @TransformFloat()
  rate!: number;
  @TransformInt()
  vehicleCategoryId?: number;
  vehicleCategoryName?: string;
  @TransformInt()
  pricingItemPresetId?: number | null;
  pricingItemPresetName?: string;
}
